export default __webpack_public_path__ + "static/8-470cc0bb535b1ce2d9063592859e3aad.png";